import { connect } from 'dva'
import { bindActionCreators } from 'redux'

import appSelector from 'models/app/selectors'
import * as appActions from 'models/app/actions'

import App from '../components/App'

function mapStateToProps(state, ownProps) {
  return Object.assign({},
    appSelector(state, ownProps),
  )
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(appActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)


// WEBPACK FOOTER //
// ./src/containers/AppContainer.js